function getBasePath(to) {
  let { fullPath } = to;
  Object.keys(to.params)
    .forEach((key) => {
      fullPath = fullPath.replace(to.params[key], key);
    });
  return fullPath;
}

export default function (to) {
  const basePath = getBasePath(to);
  window.gtag('event', 'screen_view',
    {
      app_name: 'appagendaplus',
      screen_name: basePath,
    });
}
